import dynamic from 'next/dynamic';
const TeamList = dynamic(() => import('./TeamList'));

export { TeamList };
